module.exports = __webpack_public_path__ + "static/_/src/assets/audio//click.mp3";